import React from "react";

// Hand-drawn decorative SVGs — kept subtle. All accept className.

export const ScribbleUnderline = ({ className = "", inView = false }) => (
  <svg className={className} viewBox="0 0 240 24" fill="none" aria-hidden="true">
    <path
      className={`draw-path ${inView ? "in-view" : ""}`}
      d="M4 15C40 6 78 4 120 9c38 4 74 12 116 5"
      stroke="var(--color-coral)" strokeWidth="4" strokeLinecap="round"
    />
  </svg>
);

export const ScribbleArrow = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 90 60" fill="none" aria-hidden="true">
    <path d="M5 40c20-30 42-30 60-14" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M50 20l16 6-8 15" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Star = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2l1.3 6.5L20 10l-6.7 1.5L12 18l-1.3-6.5L4 10l6.7-1.5L12 2z" fill="currentColor" />
  </svg>
);

export const Heart = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 20s-7-4.5-9.2-9C1.4 8.3 2.6 5 6 5c2 0 3.2 1.3 4 2.5C10.8 6.3 12 5 14 5c3.4 0 4.6 3.3 3.2 6-2.2 4.5-9.2 9-9.2 9z" fill="currentColor" transform="translate(2 0)" />
  </svg>
);

export const Bookmark = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M6 3h12v18l-6-4-6 4V3z" fill="currentColor" />
  </svg>
);

export const CircleScribble = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 160 90" fill="none" aria-hidden="true">
    <path d="M80 8C40 8 12 22 12 45s28 37 68 37 68-14 68-37c0-16-14-27-36-33" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Sparkle = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3v18M3 12h18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const SpeechBubble = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 64 48" fill="none" aria-hidden="true">
    <path d="M6 6h52a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H24l-12 10v-10H6a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4z" fill="currentColor" opacity="0.14" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
    <path d="M15 18h26M15 25h18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const FloatingBook = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 64 52" fill="none" aria-hidden="true">
    <rect x="2" y="6" width="30" height="40" rx="3" fill="var(--color-coral)" />
    <rect x="32" y="6" width="30" height="40" rx="3" fill="#B85E58" />
    <path d="M32 6v40" stroke="#F0C77F" strokeWidth="2" />
    <path d="M8 16h16M8 24h16M40 16h16M40 24h16" stroke="#FBF7F0" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
  </svg>
);
